import { createBlock } from './base/rsya';

jQuery(document).ready(function($) {
    var MQL = 1023,
        SHOW_UPDOWN = 900,
        $window = $(window),
        $sidebar = $('.sidebar-content'),
        $sidebarEnd = $('.sidebar__end');

    if ($window.width() > MQL) {
        const blockId = 'R-A-270753-15';
        const $block = createBlock(blockId);
        const $window = $(window);

        $sidebar.html($block.html());

        $window.on('scroll', function () {
            let bottomView = $(window).scrollTop() +
                             $(window).height(),
                             topEnd = $sidebarEnd.offset().top;
            if (bottomView > topEnd) {
                $sidebar.removeClass(
                    'sidebar-content--fixed'
                );
            } else {
               $sidebar.addClass(
                    'sidebar-content--fixed'
                ); 
            }
        });
    }
});
